module.exports = __webpack_public_path__ + "img/024f4c3d8efbdef38225bfa9655d4703ca9224b6.32144dc9.jpg";